import React from 'react';
import { z } from 'zod';
import { styled } from 'styled-components';
import type { BlockDefinition } from '../types';

// Legal-page hero — Strapi sections.privacy-policy-hero. Title + description +
// "last updated". Used by privacy-policy and cymmetri-health-privacy-policy.
export const privacyHeroSchema = z.object({
  title: z.string().min(1),
  description: z.string().optional(),
  lastUpdated: z.string().optional(),
});

type PrivacyHeroProps = z.infer<typeof privacyHeroSchema>;

const Band = styled.section`
  background: linear-gradient(93deg, #e8efff 0%, #ffffff 100%);
  padding: 8rem 1.6rem 4rem;
`;

const Inner = styled.div`
  max-width: 88rem;
  margin: 0 auto;
`;

const Title = styled.h1`
  margin: 0;
  color: #0b1020;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 600;
  font-size: clamp(3.2rem, 5vw, 5.6rem);
`;

const Description = styled.p`
  margin: 1.6rem 0 0;
  color: #4e4f52;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.7rem;
  line-height: 1.7;
`;

const Updated = styled.p`
  margin: 1.6rem 0 0;
  color: #7a7f8c;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.4rem;
`;

function PrivacyHero({ title, description, lastUpdated }: PrivacyHeroProps) {
  return (
    <Band>
      <Inner>
        <Title>{title}</Title>
        {description ? <Description>{description}</Description> : null}
        {lastUpdated ? <Updated>Last updated: {lastUpdated}</Updated> : null}
      </Inner>
    </Band>
  );
}

export const privacyHeroBlock: BlockDefinition<PrivacyHeroProps> = {
  type: 'privacyHero',
  schema: privacyHeroSchema,
  Renderer: PrivacyHero,
};
